import { useQuery } from '@tanstack/react-query'
import { Link, Navigate } from 'react-router-dom'
import { fetchRoots } from '../api'
import { useAuth } from '../auth'
import { formatBytes } from '../format'

export default function Home() {
  const { user } = useAuth()
  const roots = useQuery({ queryKey: ['roots'], queryFn: fetchRoots })

  if (roots.isPending) return <p className="muted pad">불러오는 중…</p>

  // With a single storage there is nothing to choose; go straight into it.
  if (roots.data?.length === 1) {
    return <Navigate to={`/r/${encodeURIComponent(roots.data[0]!.id)}/`} replace />
  }

  if (roots.data?.length === 0) {
    return (
      <div className="pad">
        <h1>저장소가 없습니다</h1>
        {user?.role === 'admin' ? (
          <p className="muted">
            <Link to="/admin/nodes">관리 → 노드</Link>에서 노드를 추가하고, 발급된 토큰으로 서버에
            에이전트를 실행하세요.
          </p>
        ) : (
          <p className="muted">관리자가 폴더를 공유해주면 여기에 표시됩니다.</p>
        )}
      </div>
    )
  }

  return (
    <div className="pad">
      <h1>저장소</h1>
      <div className="cards">
        {roots.data?.map((root) => (
          <Link key={root.id} to={`/r/${encodeURIComponent(root.id)}/`} className="card">
            <div className="card-title">
              <span className={`dot ${root.online ? 'online' : 'offline'}`} />
              {root.label}
            </div>
            <dl>
              <div>
                <dt>노드</dt>
                <dd>{root.nodeName}</dd>
              </div>
              <div>
                <dt>권한</dt>
                <dd>{root.permission === 'read' ? '읽기 전용' : '읽기·쓰기'}</dd>
              </div>
              <div>
                <dt>사용량</dt>
                <dd>
                  {formatBytes(root.quota.usedBytes)}
                  {root.quota.limitBytes !== null && ` / ${formatBytes(root.quota.limitBytes)}`}
                </dd>
              </div>
              <div>
                <dt>상태</dt>
                <dd>{root.online ? '온라인' : '오프라인'}</dd>
              </div>
            </dl>
          </Link>
        ))}
      </div>
    </div>
  )
}
